import type { ReactNode } from 'react';
import Pagination from './Pagination';

export interface ListWithPaginationProps {
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  children: ReactNode;
  /** When false, pagination is never shown. Default true. */
  showPagination?: boolean;
}

/**
 * Wraps list content and shows pagination below when totalPages > 1.
 * Use on any page that has a paginated list (Engins, Citernes, Jauges, etc.).
 */
export default function ListWithPagination({
  page,
  totalPages,
  onPageChange,
  children,
  showPagination = true,
}: ListWithPaginationProps) {
  return (
    <div className="space-y-4">
      {children}
      {showPagination && totalPages >= 1 && (
        <Pagination page={page} totalPages={totalPages} onPageChange={onPageChange} />
      )}
    </div>
  );
}
